import { ResponseData, ResponseError } from '../utils';

export default async (cardUuid: string, promoId: number, action: string) => {
  let url: string | undefined;

  if (action === 'viewed') {
    url = `${process.env.REACT_APP_REST_API_ADDRESS}/api/v1/promo_ads/${promoId}/viewed_ad`;
  }

  if (action === 'tapped') {
    url = `${process.env.REACT_APP_REST_API_ADDRESS}/api/v1/promo_ads/${promoId}/tapped_cta`;
  }

  const requestParams: Record<string, any> = {
    method: 'post',
    body: JSON.stringify({
      sent_mobigram_uuid: cardUuid,
    }),
    headers: {
      'Content-Type': 'application/json',
    },
  };

  if (!url) {
    return ResponseError('Wrong action.');
  }

  const response = await fetch(url, requestParams).then((res) => res.json());
  if (response?.error) {
    return ResponseError(response?.error);
  }

  return ResponseData<Record<string, any>>(response);
};
